import { ComponentProps } from 'react';
import styled, { keyframes } from 'styled-components';

const ContainerAnimation = keyframes`
  0% {
    opacity: 1;
  }

  40% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

type AnimatedContainerI = ComponentProps<'div'> & {
  doingAnimation: boolean;
};
export const AnimatedContainer = styled.div<AnimatedContainerI>`
  opacity: 1;

  animation-name: ${({ doingAnimation }): any => (doingAnimation ? ContainerAnimation : '')};
  animation-duration: 1s;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  -ms-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
`;
